module.exports = __webpack_public_path__ + "static/media/banner03.36ffb790.jpg";